// Module
var code = `<div> </div>`;
// Exports
module.exports = code;